var map = {
	"./brands.fa.svg": [
		"./src/Assets/fontawesome/svg/brands.fa.svg",
		5
	],
	"./duotone.fa.svg": [
		"./src/Assets/fontawesome/svg/duotone.fa.svg",
		6
	],
	"./light.fa.svg": [
		"./src/Assets/fontawesome/svg/light.fa.svg",
		7
	],
	"./regular.fa.svg": [
		"./src/Assets/fontawesome/svg/regular.fa.svg",
		8
	],
	"./solid.fa.svg": [
		"./src/Assets/fontawesome/svg/solid.fa.svg",
		9
	],
	"./thin.fa.svg": [
		"./src/Assets/fontawesome/svg/thin.fa.svg",
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/Assets/fontawesome/svg lazy recursive ^\\.\\/.*\\.fa\\.svg$";
module.exports = webpackAsyncContext;